import React from "react";
import { Table, Tbody, Td, Thead } from "./BiBleYear.style";

const OneToThirty = () => {
  return (
    <div>
      <Table>
        <Thead>
          <tr>
            <th scope="col-lg-2"></th>
            <th scope="col-lg-2"></th>
            <th scope="col-lg-2"></th>
            <th scope="col-lg-2"></th>
            <th scope="col-lg-2"></th>
            <th scope="col-lg-2"></th>
          </tr>
        </Thead>
        <Tbody>
          <tr>
            <Td>1</Td>
            <Td>
              <a href="http://bible.com/174/gen.1,2.thsv11">ปฐมกาล 1,2</a>
            </Td>
            <Td>
              <a href="http://bible.com/174/matt.1.thsv11">มัทธิว 1</a>
            </Td>
            <Td>
              <a href="http://bible.com/111/gen.1.niv">Genesis 1</a>,{" "}
              <a href="http://bible.com/111/gen.2.niv">2</a>
            </Td>
            <Td>Matthew 1</Td>
            <Td>ตั้งแต่เริ่มแรก</Td>
          </tr>
          <tr>
            <Td>2</Td>
            <Td>ปฐมกาล 3,4</Td>
            <Td>มัทธิว 2</Td>
            <Td>
              <a href="http://bible.com/111/gen.3.niv">Genesis 3</a>,
              <a href="http://bible.com/111/gen.4.niv">4</a>
            </Td>
            <Td>Matthew 2</Td>
            <Td>เกิดผิดพลาดขึ้นแล้ว</Td>
          </tr>
          <tr>
            <Td>3</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688751&amp;Ntype=105">
                ปฐมกาล 5,6
              </a>
            </Td>
            <Td>มัทธิว 3</Td>
            <Td>
              <a href="http://bible.com/111/gen.5.niv">Genesis 5</a>,
              <a href="http://bible.com/111/gen.6.niv"> 6</a>
            </Td>
            <Td>Matthew 3</Td>
            <Td>ต้องการหาทางออก</Td>
          </tr>
          <tr>
            <Td>4</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688752&amp;Ntype=105">
                ปฐมกาล 7,8
              </a>
            </Td>
            <Td>สดุดี 1,2</Td>
            <Td>
              <a href="http://bible.com/111/gen.7.niv">Genesis 7</a>,{" "}
              <a href="http://bible.com/111/gen.8.niv">8</a>
            </Td>
            <Td>Psalms 1,2</Td>
            <Td>พระเจ้าทรงควบคุมอยู่</Td>
          </tr>
          <tr>
            <Td>5</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688753&amp;Ntype=105">
                ปฐมกาล 9-11
              </a>
            </Td>
            <Td>มัทธิว 4</Td>
            <Td>
              Genesis 9,10,{" "}
              <a href="http://bible.com/111/gen.11.niv">11&nbsp;</a>
            </Td>
            <Td>Matthew 4</Td>
            <Td>สัญญาและหมายสำคัญ</Td>
          </tr>
          <tr>
            <Td>6</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688754&amp;Ntype=105">
                ปฐมกาล 12,13
              </a>
            </Td>
            <Td>มัทธิว 5</Td>
            <Td>Genesis 12,13</Td>
            <Td>Matthew 5</Td>
            <Td>จงทำตามและมีความสุข</Td>
          </tr>
          <tr>
            <Td>7</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688755&amp;Ntype=105">
                ปฐมกาล 14,15
              </a>
            </Td>
            <Td>สดุดี 3,4</Td>
            <Td>Genesis 14,15</Td>
            <Td>Psalms 3,4</Td>
            <Td>จงวางใจในพระเจ้า</Td>
          </tr>
          <tr>
            <Td>8</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688756&amp;Ntype=105">
                ปฐมกาล 16,17
              </a>
            </Td>
            <Td>มัทธิว 6</Td>
            <Td>Genesis 16,17</Td>
            <Td>Matthew 6</Td>
            <Td>ตามพระดำรัสสอน</Td>
          </tr>
          <tr>
            <Td>9</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688757&amp;Ntype=105">
                ปฐมกาล 18,19
              </a>
            </Td>
            <Td>มัทธิว 7</Td>
            <Td>Genesis 18,19</Td>
            <Td>Matthew 7</Td>
            <Td>ไม่ใช่เรื่องน่าหัวเราะ</Td>
          </tr>
          <tr>
            <Td>10</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688758&amp;Ntype=105">
                ปฐมกาล 20,21
              </a>
            </Td>
            <Td>มัทธิว 8</Td>
            <Td>Genesis 20,21</Td>
            <Td>Matthew 8</Td>
            <Td>สิ่งที่ทรงกระทำ</Td>
          </tr>
          <tr>
            <Td>11</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688759&amp;Ntype=105">
                ปฐมกาล 22,23
              </a>
            </Td>
            <Td>สดุดี 5,6</Td>
            <Td>Genesis 22,23</Td>
            <Td>Psalms 5,6</Td>
            <Td>ในยามทุกข์หนัก</Td>
          </tr>
          <tr>
            <Td>12</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688761&amp;Ntype=105">
                ปฐมกาล 24,25
              </a>
            </Td>
            <Td>มัทธิว 9</Td>
            <Td>Genesis 24,25</Td>
            <Td>Matthew 9</Td>
            <Td>เรื่องของความเชื่อ</Td>
          </tr>
          <tr>
            <Td>13</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688760&amp;Ntype=105">
                ปฐมกาล 26,27
              </a>
            </Td>
            <Td>มัทธิว 10</Td>
            <Td>Genesis 26,27</Td>
            <Td>Matthew 10</Td>
            <Td>เรื่องของการทรงเรียก</Td>
          </tr>
          <tr>
            <Td>14</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688762&amp;Ntype=105">
                ปฐมกาล 28,29
              </a>
            </Td>
            <Td>สดุดี 7,8</Td>
            <Td>Genesis 28,29</Td>
            <Td>Psalms 7,8</Td>
            <Td>บันไดสู่สวรรค์</Td>
          </tr>
          <tr>
            <Td>15</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688763&amp;Ntype=105">
                ปฐมกาล 30,31
              </a>
            </Td>
            <Td>มัทธิว 11</Td>
            <Td>Genesis 30,31</Td>
            <Td>Matthew 11</Td>
            <Td>ความคาดหวังที่ยิ่งใหญ่</Td>
          </tr>
          <tr>
            <Td>16</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688764&amp;Ntype=105">
                ปฐมกาล 32,33
              </a>
            </Td>
            <Td>มัทธิว 12</Td>
            <Td>Genesis 32,33</Td>
            <Td>Matthew 12</Td>
            <Td>พบปะ คำถาม ข้อเรียกร้อง</Td>
          </tr>
          <tr>
            <Td>17</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688765&amp;Ntype=105">
                ปฐมกาล 34-36
              </a>
            </Td>
            <Td>มัทธิว 13</Td>
            <Td>Genesis 34-36</Td>
            <Td>Matthew 13</Td>
            <Td>จะเล่าเรื่องให้ฟัง</Td>
          </tr>
          <tr>
            <Td>18</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688766&amp;Ntype=105">
                ปฐมกาล 37,38
              </a>
            </Td>
            <Td>สดุดี 9</Td>
            <Td>Genesis 37,38</Td>
            <Td>Psalms 9</Td>
            <Td>ไม่ได้สวยงามเสมอไป</Td>
          </tr>
          <tr>
            <Td>19</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688767&amp;Ntype=105">
                ปฐมกาล 39,40
              </a>
            </Td>
            <Td>มัทธิว 14</Td>
            <Td>Genesis 39,40</Td>
            <Td>Matthew 14</Td>
            <Td>เมื่อถูกทำให้โกรธ</Td>
          </tr>
          <tr>
            <Td>20</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688768&amp;Ntype=105">
                ปฐมกาล 41,42
              </a>
            </Td>
            <Td>มัทธิว 15</Td>
            <Td>Genesis 41,42</Td>
            <Td>Matthew 15</Td>
            <Td>ความฝันและคำทำนาย</Td>
          </tr>
          <tr>
            <Td>21</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688769&amp;Ntype=105">
                ปฐมกาล 43,44
              </a>
            </Td>
            <Td>สดุดี 10</Td>
            <Td>Genesis 43,44</Td>
            <Td>Psalms 10</Td>
            <Td>ยิ่งเลวร้ายลง</Td>
          </tr>
          <tr>
            <Td>22</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688770&amp;Ntype=105">
                ปฐมกาล 45,46
              </a>
            </Td>
            <Td>มัทธิว 16</Td>
            <Td>Genesis 45,46</Td>
            <Td>Matthew 16</Td>
            <Td>ความจริงเปิดเผย</Td>
          </tr>
          <tr>
            <Td>23</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688771&amp;Ntype=105">
                ปฐมกาล 47,48
              </a>
            </Td>
            <Td>มัทธิว 17</Td>
            <Td>Genesis 47,48</Td>
            <Td>Matthew 17</Td>
            <Td>มองต่างมุม</Td>
          </tr>
          <tr>
            <Td>24</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539688772&amp;Ntype=105">
                ปฐมกาล 49,50
              </a>
            </Td>
            <Td>มัทธิว 18</Td>
            <Td>Genesis 49,50</Td>
            <Td>Matthew 18</Td>
            <Td>เชิญเข้ามาฟังกัน</Td>
          </tr>
          <tr>
            <Td>25</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539693066&amp;Ntype=115">
                อพยพ 1,2
              </a>
            </Td>
            <Td>สดุดี 11,12</Td>
            <Td>Exodus 1,2</Td>
            <Td>Psalms 11,12</Td>
            <Td>ความช่วยเหลือกำลังมา</Td>
          </tr>
          <tr>
            <Td>26</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539693067&amp;Ntype=115">
                อพยพ 3,4
              </a>
            </Td>
            <Td>มัทธิว 19</Td>
            <Td>Exodus 3,4</Td>
            <Td>Matthew 19</Td>
            <Td>พระองค์ตรัสกับฉัน</Td>
          </tr>
          <tr>
            <Td>27</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539693068&amp;Ntype=115">
                อพยพ 5,6
              </a>
            </Td>
            <Td>มัทธิว 20</Td>
            <Td>Exodus 5,6</Td>
            <Td>Matthew 20</Td>
            <Td>ต้องยอมลงทุน</Td>
          </tr>
          <tr>
            <Td>28</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539693069&amp;Ntype=115">
                อพยพ 7,8
              </a>
            </Td>
            <Td>สดุดี 13,14</Td>
            <Td>Exodus 7,8</Td>
            <Td>Psalms 13,14</Td>
            <Td>อีกนานเท่าไร?</Td>
          </tr>
          <tr>
            <Td>29</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539693070&amp;Ntype=115">
                อพยพ 9,10
              </a>
            </Td>
            <Td>มัทธิว 21</Td>
            <Td>Exodus 9,10</Td>
            <Td>Matthew 21</Td>
            <Td>ความตึงเครียดทวีขึ้น</Td>
          </tr>
          <tr>
            <Td>30</Td>
            <Td>
              <a href="http://www.suthailand.org/index.php?lay=show&amp;ac=article&amp;Id=539693071&amp;Ntype=115">
                อพยพ 11,12
              </a>
            </Td>
            <Td>มัทธิว 22</Td>
            <Td>Exodus 11,12</Td>
            <Td>Matthew 22</Td>
            <Td>ในเวลาของพระเจ้า</Td>
          </tr>
        </Tbody>
      </Table>
    </div>
  );
};

export default OneToThirty;
